import { CommonTrackedProperties } from './CommonTrackedProperties';
import { useRouter } from '~/shared/hooks';

export function useCommonTrackedProperties(): CommonTrackedProperties {
    const { locale } = useRouter();

    return {
        ...(locale && { locale })
    };
}
